export const WORD_LENGTH = 5;
export const ACTUAL_WORD = ['W', 'O', 'R', 'D', 'L'];
export const MAX_GUESSES = 6;
